import { City, Country, RoutePickerModel } from "./RoutePickerModel";
import { isPossibleDestination } from "./StationMapper";

export type MacDictionary = Map<string, Set<string>>;

export const stationUtils = () => {
	const getPossibleDestinations = (countries: Country[], origin: City): Country[] => {
		if (!origin) return countries;

		return countries
			.map((country) => getCountryWithPossibleDestinations(country, origin))
			.filter((country) => country.cities.length > 0);
	};

	const getCountryWithPossibleDestinations = (country: Country, origin: City): Country => ({
		...country,
		cities: country.cities.filter((city) => isPossibleDestination(origin, city)),
	});

	const doesCityBeginWithSubstring = (city: City, searchExpression: string) =>
		city.code.toLowerCase().indexOf(searchExpression.toLowerCase()) === 0 ||
		getDisplayedCityName(city).toLowerCase().indexOf(searchExpression.toLowerCase()) === 0;

	// EXPORTS

	const getDisplayedCityName = (city: City) => `${city.name} (${city.code})`;

	const getFilteredModel = (model: Country[], searchExpression: string): Country[] =>
		searchExpression
			? model
					.map((country) => ({
						...country,
						cities: country.cities.filter((city) => doesCityBeginWithSubstring(city, searchExpression)),
					}))
					.filter((country) => country.cities.length)
			: model;

	const getRouteModel = (countries: Country[], selectedOrigin?: City): RoutePickerModel => {
		if (!countries) throw new Error("Station handler was not initialized.");

		if (selectedOrigin) return { countries: getPossibleDestinations(countries, selectedOrigin) };

		return { countries };
	};

	return {
		getFilteredModel,
		getRouteModel,
		isPossibleDestination,
	};
};
